module.exports = __webpack_public_path__ + "img/stock4.e34096c9.png";